<template>
  <div class="icons-container">
    <!-- <span class="text">海洋气象</span> -->
    <!-- <el-switch v-model="showWeatherIcons"
               active-color="#63defe"
               inactive-color="#6e6e6e"></el-switch> -->
    <Weather v-show="showWeatherIcons"
             :viewer="viewer"
             :showWeatherIcons="showWeatherIcons"
             :isRotation="isRotation"
             :changeRotation="changeRotation"
             :clientWidth="clientWidth"
             ref="Weather"
             :lonlat="lonlat"></Weather>
    <Typhoon v-show="showWeatherIcons"
             :viewer="viewer"
             :showWeatherIcons="showWeatherIcons"
             ref="Typhoon"
             :clientWidth="clientWidth"
             :clientHeight="clientHeight"></Typhoon>
    <div>
      <img class="mapType-icon" title="二三维切换" src="../../assets/png/mapchange.png" @click="changeMap()"/>
    </div>
    <div>
      <img class="seamap-icon" title="海图" :src="seamapUrl" @click="changeSeaLayerStatus()"/>
    </div>
    <left-tools :viewer="viewer" ref="LeftTools"></left-tools>
  </div>

</template>
  
<script>
import { defineComponent } from "vue";
import Weather from "./weather.vue";
import Typhoon from "./typhoon.vue";
import LeftTools from "./leftTools.vue"
import {mapActions} from 'vuex'
import seamap from '@/assets/png/seamap.png'
import unSeamap from '@/assets/png/seamap_un.png'

export default defineComponent({
  name: "MeteoBar",
  components: { Weather, Typhoon, LeftTools },
  props: {
    clientWidth: {
      type: Number,
      default: () => {
        return null;
      },
    },
    clientHeight: {
      type: Number,
      default: () => {
        return null;
      },
    },
    viewer: {
      type: Object,
      default: () => {
        return null;
      },
    },
    isRotation: {
      type: Boolean,
      default: () => {
        return null;
      },
    },
    changeRotation: {
      type: Function,
      default: () => {
        return null;
      },
    },
    lonlat: {
      type: Array,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      showWeatherIcons: true,
      isShowSeaMap: false,
      seamapUrl: unSeamap
    };
  },
  watch: {
    showWeatherIcons(newV) {
      this.SET_SHOW_WEATHER_ICONS(newV)
    }
  },
  mounted() {},
  beforeDestroy() {},
  computed: {
    clientWidthScale() {
      return this.clientWidth / 1000;
    },
  },
  methods: {
    ...mapActions(['SET_SHOW_WEATHER_ICONS']),

    changeMap() {
      this.viewer.mapChange()
    },

    changeSeaLayerStatus() {
      this.isShowSeaMap = !this.isShowSeaMap
      const elements = document.getElementsByClassName('card')
      for(let i=0; i<elements.length; i++) {
        const element = elements.item(i)
        element.style.backgroundColor = this.isShowSeaMap ? 'rgba(0, 0, 0, 0.8)' : 'rgba(72, 156, 255, 0.2)'
      }
      if(this.isShowSeaMap) {
        this.seamapUrl = seamap
      }else{
        this.seamapUrl = unSeamap
      }
      this.viewer.seaLayerControl()
    },

    clearWeather() {
      this.$refs.Weather.clearWeatherLayer()
    },
    resetWeather(mapType) {
      this.$refs.Weather.resetWeatherLayer(mapType)
    }
  },
});
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../styles/variables";
@media screen and (max-width: 1500px) {
  .icons-container {
    position: absolute;
    // top: 70px;
    top: 95px;
    right: 20px;
    text-align: right;

    .text {
      color: #fff;
      font-size: 13px;
      padding-right: 5px;
    }
  }

  .el-switch__core {
    width: 32px !important;
    height: 16px !important;
  }

  .el-switch__action {
    width: 12px !important;
    height: 12px !important;
  }

  .el-switch.is-checked .el-switch__action {
    margin-left: -12px !important;
  }
}

@media screen and (min-width: 1501px) {
  .icons-container {
    position: absolute;
    top: calc($header-height-1920 + 10px);
    right: 20px;
    text-align: right;

    .text {
      color: #fff;
      font-size: 13px;
      padding-right: 5px;
    }

    .mapType-icon {
      height: $icon-height-1920;
      cursor: pointer;
      box-sizing: border-box;
      width: 33px;
      opacity: 0.7;
    }

    .seamap-icon {
      height: $icon-height-1920;
      cursor: pointer;
      box-sizing: border-box;
      width: 33px;
      opacity: 0.7;
    }
  }

  .el-switch__core {
    width: 32px !important;
    height: 16px !important;
  }

  .el-switch__action {
    width: 12px !important;
    height: 12px !important;
  }

  .el-switch.is-checked .el-switch__action {
    margin-left: -12px !important;
  }
}

@media screen and (min-width: 1921px) {
  .icons-container {
    position: absolute;
    top: calc($header-height-2560 + 20px);
    right: 26%;
    text-align: right;

    .text {
      color: #fff;
      font-size: 24px;
      padding-right: 10px;
    }

    .mapType-icon {
      height: $icon-height-2560;
      width: $icon-width-2560;
      cursor: pointer;
      box-sizing: border-box;
      opacity: 0.7;
    }
  }

  .el-switch__core {
    width: 50px !important;
    height: 30px !important;
    border-radius: 15px;
  }

  .el-switch__action {
    width: 24px !important;
    height: 24px !important;
  }

  .el-switch.is-checked .el-switch__action {
    margin-left: -24px !important;
  }
}

@media screen and (min-width: 2561px) {
  .icons-container {
    position: absolute;
    top: calc($header-height-4368 + 80px);
    right: 22%;
    text-align: right;

    .text {
      color: #fff;
      font-size: 36px;
      padding-right: 20px;
    }

    .mapType-icon {
      height: $icon-height-4368;
      width: $icon-width-4368;
      cursor: pointer;
      box-sizing: border-box;
      margin: 5px 0;
      opacity: 0.7;
    }
  }

  .el-switch__core {
    width: 80px !important;
    height: 40px !important;
    border-radius: 20px;
  }

  .el-switch__action {
    width: 36px !important;
    height: 36px !important;
  }

  .el-switch.is-checked .el-switch__action {
    margin-left: -36px !important;
  }
}

@media screen and (min-width: 6700px) {
  .icons-container {
    position: absolute;
    // top: 340px;
    top: calc($header-height-6720 + 30px);
    right: 20%;
    text-align: right;

    .text {
      color: #fff;
      font-size: 48px;
      padding-right: 30px;
    }

    .mapType-icon {
      height: $icon-height-6720;
      width: $icon-width-6720;
      cursor: pointer;
      box-sizing: border-box;
      margin: 10px 0;
      opacity: 0.7;
    }
  }

  .el-switch__core {
    width: 120px !important;
    height: 50px !important;
    border-radius: 25px;
  }

  .el-switch__action {
    width: 44px !important;
    height: 44px !important;
  }

  .el-switch.is-checked .el-switch__action {
    margin-left: -44px !important;
  }
}

.cesium-viewer-bottom {
  display: none !important;
}
</style>
  